// Module
var code = `<div class="js-mutualClose-main">
    <div class="js-mutualClose-body">
        <div class="js-mutualClose-labels-container">
            <terceraLabel name="symbolLabel" text="{{.symbolLabel}}" />
            <terceraLabel name="symbolValue" additionalClass="symbol-value" text="{{.symbolName}}" />
        </div>
        <div class="js-mutualClose-table">
            <terceraPanel name="windowPanelBodyQT" />
        </div>
        <div class="js-mutualClose-labels-container">
            <terceraLabel name="totalLabel" text="{{.totalLabel}}" />
            <terceraLabel name="totalLabelValue" additionalClass="{{totalValueStyle}}" text="{{.totalValuePrefix}} {{.totalValueFormatted}}" />
        </div>
    </div>
    <div class="js-mutualClose-footer">
        <terceraButton name="closePosBtn" text="{{.closePosBtnText}}" enabled="{{.enabledBtn}}" terceraButtonStyle="js-button-blue style-with-92" on-btnClick="modifyBtnClick" />
        <terceraButton name="cancelBtn" text="{{.cancelBtnText}}" terceraButtonStyle="js-button-gray25 style-with-92" on-btnClick="cancelBtnClick" />
    </div>
</div>`;
// Exports
export default code;